import LoadingButton, { LoadingButtonProps } from "@mui/lab/LoadingButton";
import { styled } from "@mui/material/styles";

export default styled(LoadingButton)<LoadingButtonProps & { look: 'light' | 'normal'}>(({ theme }) => {
  return {
    textTransform: "uppercase",
    padding: theme.spacing(1, 2),
    boxShadow: "none",

    "@media print": {
      display: "none",
    },

    "&.MuiButton-containedPrimary": {
      backgroundColor: "transparent",
      color: theme.palette.text.primary,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.secondary.main,
      borderRadius: theme.shape.borderRadius,
      fontWeight: theme.typography.fontWeightMedium,
      letterSpacing: theme.spacing(0.25),
      fontSize: 12,
      lineHeight: 1,

      "&:hover, &:focus, &:active": {
        boxShadow: "none",
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.text.secondary,
      },

      "&.MuiButton-sizeSmall": {
        height: 34,
      },

      "&.MuiButton-sizeMedium": {
        height: 44,
      },

      "&.MuiButton-sizeLarge": {
        height: 50,
      },

      "&.Mui-disabled": {
        color: theme.palette.text.disabled,
        borderColor: theme.palette.secondary.light,
      },

      "& .MuiLoadingButton-loadingIndicator": {
        position: "initial",
        marginLeft: theme.spacing(1),
      },
      "& .MuiButton-endIcon": {
        marginLeft: theme.spacing(0.5),
      },
    },
  };
});

export const InvertButton = styled(LoadingButton)<LoadingButtonProps>(({ theme }) => {
  return {
    textTransform: "uppercase",
    padding: theme.spacing(1, 2),
    boxShadow: "none",

    "@media print": {
      display: "none",
    },

    "&.MuiButton-containedPrimary": {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.common.white,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.success.main,
      borderRadius: theme.shape.borderRadius,
      fontWeight: theme.typography.fontWeightMedium,
      letterSpacing: theme.spacing(0.25),
      fontSize: 12,
      lineHeight: 1,

      "&:hover, &:focus, &:active": {
        boxShadow: "none",
        backgroundColor: theme.palette.text.secondary,
        color: theme.palette.success.main,
      },

      "&.MuiButton-sizeSmall": {
        height: 34,
      },

      "&.MuiButton-sizeMedium": {
        height: 44,
      },

      "&.MuiButton-sizeLarge": {
        height: 50,
      },

      "&.Mui-disabled": {
        color: theme.palette.text.disabled,
        borderColor: theme.palette.secondary.light,
      },

      "& .MuiLoadingButton-loadingIndicator": {
        position: "initial",
        marginLeft: theme.spacing(1),
      },
      "& .MuiButton-endIcon": {
        marginLeft: theme.spacing(0.5),
      },
    },
  };
});
